import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const discussionsApi = {
    getDiscussions: (projectId: number): Observable<Dtos.GetDiscussionsResponse> => {
        //Create the request.
        let request: Dtos.GetDiscussions = new Dtos.GetDiscussions();
        request.projectId = projectId;

        //Send request.
        const response: Promise<Dtos.GetDiscussionsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getDiscussionById: (id: number): Observable<Dtos.GetDiscussionByIdResponse> => {
        //Create the request.
        let request: Dtos.GetDiscussionById = new Dtos.GetDiscussionById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetDiscussionByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setDiscussion: (discussion: Dtos.Discussion): Observable<Dtos.SetDiscussionResponse> => {

        let request: Dtos.SetDiscussion = new Dtos.SetDiscussion();

        request.discussion = discussion;

        // send request
        const response: Promise<Dtos.SetDiscussionResponse> = client.post(request);

        return Observable.from(response);
    },
    createDiscussion: (projectId: number): Observable<Dtos.CreateDiscussionResponse> => {
        //Create the request.
        let request: Dtos.CreateDiscussion = new Dtos.CreateDiscussion();

        request.projectId = projectId;

        //Send request.
        const response: Promise<Dtos.CreateDiscussionResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateDiscussion: (discussion: Dtos.Discussion): Observable<Dtos.ValidateDiscussionResponse> => {

        let request: Dtos.ValidateDiscussion = new Dtos.ValidateDiscussion();

        request.discussion = discussion;

        // send request
        const response: Promise<Dtos.ValidateDiscussionResponse> = client.post(request);

        return Observable.from(response);
    }
}